import script from "./CircuitosView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CircuitosView.vue?vue&type=script&lang=ts&setup=true"

import "./CircuitosView.vue?vue&type=style&index=0&id=6e79b60c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e79b60c"]])

export default __exports__